export default "__VITE_ASSET__D9FT93Zj__"